import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthAccountSubAccountClosedError } from '@/core/error/transport/auth/TmAuthAccountSubAccountClosedError'

export const authSubAccountClosedErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  subCodes: ['auth.subaccount_closed'],
  klass: TmAuthAccountSubAccountClosedError,
}
